import React from "react";
import { Form, FormItemProps } from "antd";
import { color } from "theme/Color";
import { typography } from "theme/Typography";

interface Props extends FormItemProps {
  name?: string | string[];
  label?: string;
  rules?: any[];
  className?: string;
  children: React.ReactNode;
  validateTrigger?: any;
  initialValue?: string | string[] | Date | number | any;
}

const CustomFormItem: React.FC<Props> = ({
  name,
  label,
  rules,
  children,
  validateTrigger,
  initialValue,
  ...others
}) => {
  return (
    <Form.Item
      name={name}
      label={
        <span
          style={{
            fontSize: typography.fontSizes.sm,
            fontWeight: typography.fontWeights.medium,
            lineHeight: "20px",
            color: color.INPUT_TEXT,
          }}
        >
          {label}
        </span>
      }
      rules={rules}
      validateTrigger={validateTrigger}
      initialValue={initialValue}
      {...others}
    >
      {children}
    </Form.Item>
  );
};

export default CustomFormItem;
